import { render, staticRenderFns } from "./AssignedJobCategoryTag.vue?vue&type=template&id=450203a6&scoped=true"
import script from "./AssignedJobCategoryTag.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignedJobCategoryTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AssignedJobCategoryTag.vue?vue&type=style&index=0&id=450203a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450203a6",
  null
  
)

export default component.exports